module.exports = __webpack_public_path__ + "img/blank_canvas.d32ae8cf.svg";